export default {
  trd_want: 'Want',
  trd_order: 'Order',
  trd_base: 'Base',
  trd_quote: 'Quote',
  trd_price: 'Price',
  trd_created: 'Created',
  trd_ask: 'Ask',
  trd_bid: 'Bid',
  trd_offer_canceled: 'Offer successfully cancelled',
  trd_offer_created: 'Offer successfully created',
  trd_offer_failed_to_cancel: 'Failed to cancel offer',
  trd_order_not_enough_funds: 'Not enough funds!',
  trd_some_went_wrong: 'Something went wrong!',
  trd_no_trade_history: 'No trade history',
  trd_no_orders_history: 'No orders',
  trd_here_will_be_the_list: 'Here will be the list of completed trades',
  trd_here_will_be_the_order_list: 'Here will be the list of current orders',
  trd_here_will_be_the_order_ask_list: 'Here will be the list of current asks',
  trd_here_will_be_the_order_bid_list: 'Here will be the list of current bids',
  trd_validate_minimal_price: 'Price must be more than 0',
  trd_validate_minimal_amount: 'Minimal amount is 0.000001',
  trd_price_per: 'Price per %{asset}',
  trd_amount_for: 'Amount %{asset}',
  trd_total_value: 'Total %{value}',
  trd_total_sell: 'Sell %{asset}',
  trd_will_receive: 'I will get %{value}',
  trd_create_sell_order: 'Create SELL %{value} order',
  trd_create_buy_order: 'Create BUY %{value} order',
  trd_history: 'Trade History',
  trd_history_amount: 'Amount (%{asset})',
  trd_history_price: 'Price (%{asset})',
  trd_history_total: 'Total (%{asset})',
  trd_history_time: 'Time',
  trd_manage: 'Your open %{pair} orders',
  trd_manage_date: 'Date',
  trd_manage_market: 'Market',
  trd_manage_order: 'Order',
  trd_order_wdrawal: 'Source amount',
  trd_manage_base_asset_amount: 'Base asset amount',
  trd_manage_quote_asset_price: 'Price in quote asset',
  trd_order_buy: 'Buy',
  trd_order_sell: 'Sell',
  trd_market_price: 'Market price',
  trd_since_last: 'since last %{value}',
  trd_chart_hour: 'Hour',
  trd_chart_day: 'Day',
  trd_chart_month: 'Month',
  trd_chart_year: 'Year',
  trd_orders: 'Open orders',
  trd_confirm_match: 'By pressing confirm, you will create the opposite to selected order',
  trd_no_pairs: 'No tradable pairs',
  trd_no_pairs_exp: 'This feature will be available once any tradable pair appears',
  trd_no_exchange_pairs: 'No registered exchange pairs',
  trd_no_exchange_pairs_exp: 'This feature will be available once any exchange pair appears',
  trd_load_rates_failed: 'Error loading rates for source %{source}',
  trd_balance: 'Your balance is %{base} / %{quote}'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/trade_view.js